import { Page } from 'layouts/Page';
import { FC } from 'react';
import { ErrorItem } from 'components/ErrorsCorrections/ErrorItem';

export const ErrorItemPage: FC = () => {
	return (
		<Page title="Error Correction – EAS Control Center">
			<ErrorItem />
		</Page>
	);
};
